/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';
import { API_URLU } from '../config/constant';

const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user/', data, { headers: authHeader() });
};

const getByUsername = (username) => {
  return axios.get(API_URLU + 'userName/' + username, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system/' + id, { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany', data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };
const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

const getCustomerById = (id) => {
  return axios.get(API_URLU + 'customer/' + id, { headers: authHeader() });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const putCustomer = (id, data) => {
  return axios.put(API_URLU + 'customer/' + id, data, { headers: authHeader() });
};

const getEmployeeByCode = (id) => {
  return axios.get(API_URLU + 'chr_by_code/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_vusername/' + name, { headers: authHeader() });
};

const getEmployeeDepartments = (id) => {
  return axios.get(API_URLU + 'chr_deptartments/' + id, { headers: authHeader() });
};

const getEmployeeByCategoryCode = (code) => {
  return axios.get(API_URLU + 'chr_by_category/' + code, { headers: authHeader() });
};

const getEmployeeByDepartmentCode = (code) => {
  return axios.get(API_URLU + 'depart_employees?departmentCode=' + code, { headers: authHeader() });
};

const getEmployeeLeaveByDepartmentCode = (code) => {
  return axios.get(API_URLU + 'depart_employee-leave?departmentCode=' + code, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + 'chr_employee', data, { headers: authHeader() });
};

const putEmployee = (data) => {
  return axios.put(API_URLU + 'chr_employee/' + data.empId, data, { headers: authHeader() });
};

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'tbranch', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'tbranch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = (employeCode) => {
  return axios.get(API_URLU + 'scheduled_leaves?employeeCode=' + employeCode, { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals', { headers: authHeader() });
};

const getLeaveAccrualsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveAccrualsVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const getLeaveApplicationsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveApplicationVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveTransactionsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveTransactionVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const getCompletedTasks = () => {
  return axios.get(API_URLU + 'completedTasks',{headers: authHeader()});
  };
const getPendingTasks = () => {
  return axios.get(API_URLU + 'pendingTasks',{headers: authHeader()});
};
const getDiscardedTasks = () => {
  return axios.get(API_URLU + 'discardedTasks',{headers: authHeader()});
  };
const getLeaveRejections = (employeCode) => {
  return axios.get(API_URLU + 'leave_rejections?employeeCode=' + employeCode, { headers: authHeader() });
};

const getLeaveTypes = (employeeCode) => {
  return axios.get(API_URLU + 'leave_types?employeeCode=' + employeeCode, { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
      'return_date?startDate=' +
      data.startDate +
      '&appliedDays=' +
      data.appliedDays +
      '&leaveCode=' +
      data.leaveCode +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const getEmpCategory = () => {
  return axios.get(API_URLU + 'icr_employee_category', { headers: authHeader() });
};

const postEmpCategory = (data) => {
  return axios.post(API_URLU + 'icr_employee_category', data, { headers: authHeader() });
};

const getBanks = () => {
  return axios.get(API_URLU + 'sac-bank-branches', { headers: authHeader() });
};

const getEmpRecurrents = (code) => {
  return axios.get(API_URLU + 'chr_emp_recurrentbycode/' + code, { headers: authHeader() });
};

const getPayPeriods = (data) => {
  return axios.get(API_URLU + 'pay-period?period=' + data.period, { headers: authHeader() });
};

const getChrTempMonthlies = (data) => {
  return axios.get(API_URLU + 'chr_temp_monthlies_byCode?employeeCode=' + data.employeeCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getChrMonthliesView = (data) => {
  return axios.get(API_URLU + 'chr_temp_monthlies_view?employeeCode=' + data.employeeCode + '&period=' + data.period, {
    headers: authHeader()
  });
};

const getChrEerMonthliesView = (data) => {
  return axios.get(API_URLU + 'chr_temp_eer_monthlies_view?employeeCode=' + data.employeeCode + '&period=' + data.period, {
    headers: authHeader()
  });
};

// const uploadFile = (file) => {
//   let formData = new FormData();

//   formData.append('file', file);
//   return axios.post(API_URLU + 'singleUpload', formData, { headers: authHeader() });
// };

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const getMonthlyFigures = (data) => {
  return axios.get(
    API_URLU +
      'genMonthlyFigures?cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode +
      '&period=' +
      data.period +
      '&employeeCode=' +
      data.employeeCode +
      '&username=' +
      data.username +
      '&pFromDate=' +
      data.pFromDate +
      '&pToDate=' +
      data.pToDate,
    { headers: authHeader() }
  );
};

const purgeMonthlyFigures = (data) => {
  return axios.get(API_URLU + 'purgeMonthlyFigures?employeeCode=' + data.employeeCode + '&categoryCode=' + data.categoryCode, {
    headers: authHeader()
  });
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getApprovalRights = (username) => {
  return axios.get(API_URLU + 'chr_approve_rights_username?userName=' + username, { headers: authHeader() });
};

const getReports = () => {
  return axios.get(API_URLU + 'temp_pay_reports', { headers: authHeader() });
};

const runReport = (repname, format, period) => {
  return axios.get(API_URLU + 'report/' + repname + '/' + format + '?period=' + period, { headers: authHeader() });
};

const getProvpayvarsum2 = (period) => {
  return axios.get(API_URLU + 'chr_rp_hrProvpayvarsum2?period=' + period, { headers: authHeader() });
};

const preparatoryApp = (data) => {
  return axios.get(
    API_URLU +
      'preparatory_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const verificationApp = (data) => {
  return axios.get(
    API_URLU +
      'verification_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const finalApp = (data) => {
  return axios.get(
    API_URLU +
      'final_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const getPayMonthSummary = (data) => {
  return axios.get(API_URLU + 'chr_pay_month_sum?period=' + data.period + '&categoryCode=' + data.categoryCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getFinalMonthliesCount = (period) => {
  return axios.get(API_URLU + 'chr_final_monthlies_count?period=' + period, { headers: authHeader() });
};

const getCloseCurrentPeriod = (username) => {
  return axios.get(API_URLU + 'close_current_period?username=' + username, { headers: authHeader() });
};

const getRecurrents_ed = (data) => {
  return axios.get(API_URLU + 'chr_recurrents_ed?employeeCode=' + data.employeeCode, { headers: authHeader() });
};

const saveRecurrents_ed = (data) => {
  return axios.get(
    API_URLU +
      'save-recurrent?employeeCode=' +
      data.employeeCode +
      '&paramCode=' +
      data.paramCode +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&edAmount=' +
      data.edAmount +
      '&eerContribute=' +
      data.eerContribute +
      '&eerPA=' +
      data.eerPA +
      '&eerVal=' +
      data.eerVal +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const updateRecurrents_ed = (data) => {
  return axios.get(
    API_URLU +
      'update-recurrent?edAmount=' +
      data.edAmount +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&ercId=' +
      data.ercId +
      '&eerContribute=' +
      data.eerContribute +
      '&eerPA=' +
      data.eerPA +
      '&eerVal=' +
      data.eerVal,
    { headers: authHeader() }
  );
};

const getPayParams = () => {
  return axios.get(API_URLU + 'pay_params', { headers: authHeader() });
};

const getMenuLevels = (data) => {
  return axios.get(API_URLU + 'get-menusbk?cmpId=' + data.cmpId + '&accessId=' + data.accessId + '&sstId=' + data.sstId, {
    headers: authHeader()
  });
};

const getAttendance = (code) => {
  return axios.get(API_URLU + 'employee-attendance-list?employeeCode=' + code, {
    headers: authHeader()
  });
};

const genAttendanceAll = (code) => {
  return axios.get(
    API_URLU + 'gen-attendance-all?firstDate=' + code.firstDate + '&lastDate=' + code.lastDate + '&username=' + code.username,
    {
      headers: authHeader()
    }
  );
};

const getTaskScheduleByEmpCode = (code) => {
  return axios.get(API_URLU + 'task-schedule-empCode/' + code, { headers: authHeader() });
};

const getTaskRequestByEmpCode = (code) => {
  return axios.get(API_URLU + 'task-request-empCode/' + code, { headers: authHeader() });
};

const getTaskRequestByDepCode = (code) => {
  return axios.get(API_URLU + 'task-request-depCode/' + code, { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + 'get-departments', {
    headers: authHeader()
  });
};

const getHdeskTypes = () => {
  return axios.get(API_URLU + 'get-hdesk-types', {
    headers: authHeader()
  });
};

const postTaskRequest = (data) => {
  return axios.post(API_URLU + 'task-request', data, { headers: authHeader() });
};

const postTaskSchedule = (data) => {
  return axios.post(API_URLU + 'task-schedule', data, { headers: authHeader() });
};

const getDepartEmployees = (code) => {
  return axios.get(API_URLU + 'get-depart-emp?departmentCode=' + code, {
    headers: authHeader()
  });
};

const getHodTaskApproval = (code) => {
  return axios.get(API_URLU + 'hod-approve-task?hdeskId=' + code, {
    headers: authHeader()
  });
};

const postDoneStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-done-status?done=' +
      data.doneYn +
      '&doneBy=' +
      data.doneBy +
      '&doneComments=' +
      data.doneDescription +
      '&doneDate=' +
      data.doneDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const postCloseStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-close-status?closed=' +
      data.closeYn +
      '&closedBy=' +
      data.closedBy +
      '&closedComments=' +
      data.closedDescription +
      '&closedDate=' +
      data.closedDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const postDiscardedStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-discarded-status?discarded=' +
      data.discarded +
      '&discardedBy=' +
      data.discardedBy +
      '&discardedReason=' +
      data.discardedReason +
      '&discardedDate=' +
      data.discardedDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const getAppraisalTypes = () => {
  return axios.get(API_URLU + 'get-app-types', {headers: authHeader()});
}

const postAppraisalTasks = (data) => {
  return axios.get(API_URLU + 'save_appraisal_tasks?tranYear=' + data.tranYear + '&tranMonth=' + data.tranMonth + '&indDeptComp=' + data.indDeptComp + '&appraisalType=' +data.appraisalType + '&taskDate=' + data.taskDate + '&reviewEndDate=' +data.revEndDate + '&firstRevDate=' +data.firstRevDate + '&secRevDate=' +data.secondRevDate + '&thirdRevDate=' + data.thirdRevDate + '&actualAppDate=' + data.actualAppDate, {headers: authHeader()});
}

const getAppraisalTaskAreas = () => {
  return axios.get(API_URLU + 'get-app-factors', {headers: authHeader()});
}


const saveAppraisalTaskAreas =(data) => {
  return axios.get(API_URLU + 'savePerpectives?atsId=' + data.atsId + '&factorCode=' + data.code +'&lines=' +data.lines+ '&category=' +data.category, {headers: authHeader()});
}

const generateAppraisalTemplate = (data) => {
  return axios .get(API_URLU + 'gen-appraisal-tasks?atsId=' + data.atsId + '&cmpId=' + data.cmpId + '&indDeptComp=' + data.indDeptComp + '&deptCode=' + data.deptCode + '&empCode=' + data.empCode + '&appType=' + data.appType + '&usrId=' + data.usrId+ '&actualAppDate=' + data.actualAppDate+ '&firstRevDate=' + data.firstRevDate + '&appTaskDate=' + data.appTaskDate + '&secondRevDate=' + data.secondRevDate + '&thirdRevDate=' + data.thirdRevDate + '&reviewEndDate=' + data.reviewEndDate, {headers: authHeader()});
}

const getAppraisalSchedules = (data) => {
  return axios.get(API_URLU + 'appraisal-schedules?employeeCode=' + data.employeeCode, {headers: authHeader()});
}

const getUserAppraisalSchedules = (data) => {
  return axios.get(API_URLU + 'appraisal-schedules?employeeCode=' + data, {headers: authHeader()});
}

const getAppraisalScoresa = (data) => {
  return axios.get(API_URLU + 'appraisal-scoresa?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode, {headers: authHeader()});
}

const fetchAppEdit = (rowData) => {
  return axios.get(API_URLU + 'appraisal-scoresa?atsId=' + rowData.atsId + '&employeeCode=' + rowData.employeeCode, {headers: authHeader()});
}

const getAppraisalScores = (data) => {
  return axios.get(API_URLU + 'appraisal-scores?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode + '&sectionCode=' + data.sectionCode + '&measureId=' + data.measureId, {headers: authHeader()});
}

const getIndItem = (data) => {
  return axios.get(API_URLU + 'getIndReqs?reqNumber='+data.reqNumber,{headers:authHeader()});
}

const updateAppraisalScores = (data) => {
  return axios.get(API_URLU + 'update-appraisal-score?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode + '&sectionCode=' +data.sectionCode+ '&measureId=' +data.measureId +
    '&objectiveDescr=' +data.objectiveDescr+ '&initiativeDescr=' +data.initiativeDescr+ '&measureDescr=' + '&target=' +data.target +
     '&apprAchievement=' + data.apprAchievement+ '&status=' +data.status+ '&initiativeToEndYear=' + data.initiativeToEndYear +
     '&proExtention=' + data.proExtention + '&directorysComments=' +data.directorysComments+ '&selfRating=' +data.selfRating + '&finalRating=' + data.finalRating + '&overall=' +data.overall + '&modifiedBy=' + data.modifiedBy + '&modifiedDate=' + data.modifiedDate, {headers: authHeader()});
}

const printRept = (data) => {
  return axios.get(API_URLU + 'appraisal-reports?reportFormat=?' + data.reportFormat + '&repName=' + data.repName + '&atsId=' + data.atsId + '&employeeCode=' + data.employeeCode, {headers: authHeader()});
}


const signDocument = (data) => {
  return axios.get(API_URLU + 'signDoc?atsId=' + data.atsId + '&employeeCode=' + data.empId,{headers: authHeader()})
}

const getPendingRegs = (data) => {
  return axios.get(API_URLU + 'getPendingReqs?employeeCode=' + data, {headers: authHeader()})
}

const getRejectedApprovedRegs = (data) => {
  return axios.get(API_URLU + 'getPendingapprovalReqs?employeeCode=' + data, {headers: authHeader()})
}

const getAllApprovedReqs = () => {
  return axios.get(API_URLU + 'getAllApprovedReqs',{headers:authHeader()})
}

const getAllIssuedReqs = () => {
  return axios.get(API_URLU + 'getAllIssuedReqs',{headers:authHeader()})
}

const updateItemReq = (data) => {
  return axios.get(API_URLU + 'updateIndReqItem?reqNumber=' + data, {headers: authHeader()})
}
const getApprovedReqs = (data) => {
  return axios.get(API_URLU + 'getApprovedReqs?employeeCode=' + data, {headers: authHeader()})
}

const getItemReqs = async(data) => {
  return axios.get(API_URLU + 'getItemReqs?reqType=' + data, {headers: authHeader()})
}

const storeRequisitions = async(data) =>{
  return axios.get(API_URLU + 'storeRequisitions?p_req_TYPE=' + data.code + '&p_item_CODE=' + data.itemcode + '&p_unit_CODE=' + data.unitcode + '&p_no_of_UNITS=' + data.noofunits + '&p_employeeCode=' + data.employeeCode + '&p_USERNAME=' + data.username + '&p_io_TYPE=' + data.ioType + '&p_branch_CODE=' + data.branch + '&p_departments_CODE=' + data.department + '&p_request_COMMENTS=' + data.comments, {headers:authHeader()})
}

const getRejectedReqs = (data) => {
  return axios.get(API_URLU + 'getRejectedReqs?employeeCode=' + data, {headers: authHeader()})
}
const updateItemReqStatus = (data) =>{
  return axios.get(API_URLU + 'updateIndReqItem?reqNumber=' + data.id + '&approvedBy=' + data.approvedBy + '&approvedDate=' + data.approvedDate, {headers:authHeader()})
}
const updateItemIssued = (data) => {
  return axios.get(API_URLU + 'updateItemIssued?reqNumber=' + data.reqNumber + '&issued=' + data.issued + '&issued_units='  + data.issued_units + '&issuedUnitCode=' + data.issuedUnitCode + '&dateIssued=' + data.dateIssued + '&issuedBy=' + data.issuedBy + '&receivedDate=' + data.receivedDate, {headers: authHeader()})
}
const recallApproval = (data) => {
  return axios.get(API_URLU + 'recalApprovedItem?reqNumber=' + data.reqNumber, {headers:authHeader()})
}

const updateItemUnit = (data) => {
  return axios.get(API_URLU + 'changeNoofItem?no_OF_UNITS=' + data.no_OF_UNITS + '&reqNumber=' + data.reqNumber , {headers:authHeader()})
}

const changeTaskState = (data) => {
  return axios.get(API_URLU + 'close_discard_tasks?employeeCode=' + data.employeeCODE + '&taskId=' + data.taskId + '&status=' + data.state, {headers: authHeader()})
}
const getAppPositions = (appId) => {
  return axios.get(API_URLU + 'app-positions?appId='+ appId,{headers:authHeader()});
}

const getAppQualifications = (appId) => {
  return axios.get(API_URLU + 'app-qualification?appId='+ appId,{headers:authHeader()});
}

const PostAppQualifications = (data) => {
  return axios.post(API_URLU + 'app-qualification', data, {headers:authHeader()});
}

const updateAppQualifications = (data) => {
  return axios.put(API_URLU + 'app-qualification/' + data.pqlId, data, {headers:authHeader()});
}

const getAppextraCur = (appId) => {
  return axios.get(API_URLU + 'app-extra-cur?appId='+ appId,{headers:authHeader()});
}

const PostAppextraCur = (data) => {
  return axios.post(API_URLU + 'app-extra-cur', data, {headers:authHeader()});
}

const updateAppextraCur = (data) => {
  return axios.put(API_URLU + 'app-extra-cur/' + data.pxcId, data, {headers:authHeader()});
}

const getEmployeebyCmp = (id) => {
  return axios.get(API_URLU + 'get-cmp-employees?cmpId=' +id, {headers:authHeader()});
}

const listPayParams = () =>{
  return axios.get(API_URLU + 'list-pay-param', {headers: authHeader()});
}

const findPayParamById = (id) =>{
  return axios.get(API_URLU + 'find-payparam-id?pypId=' + id, {headers: authHeader()});
}

const fetchPayCodes = () => {
  return axios.get(API_URLU + 'list-pay-codes' ,{headers: authHeader()});
}

const fetchAccoutCodes = (cmpId) => {
  return axios.get(API_URLU + 'account-codes?cmpId=' + cmpId, {headers: authHeader()});
}

const deleteChrLeaveApplications = (lppId) => {
  return axios.delete(API_URLU + 'pending-leaves?lppId=' + lppId, {headers:authHeader()});
}

const fetchMailingList =(deptCode) => {
  return axios.get(API_URLU + 'dept-mailing-list?deptCode=' + deptCode, {headers:authHeader()});
}

const sendLeaveUpdates = (data) => {
  return axios.get(API_URLU + 'send-leave-updates?lppId=' + data.lppId  + '&empCode=' + data.empCode + '&leaveCode=' + data.leaveCode + '&appliedDays=' + data.appliedDays + '&reasonApplied=' + data.reasonApplied + '&fromDate=' + data.fromDate + '&returnDate=' + data.returnDate, {headers: authHeader()});
}

const sendEmailAlerts = (data) => {
  return axios.post(API_URLU + 'save-outgoing emails', data, {headers:authHeader()});
}

const savePayParams = (data) => {
  return axios.post(API_URLU + 'post-pay-params', data, {headers: authHeader()});
}

const loanIntParams = () => {
  return axios.get(API_URLU + 'payparams', {headers: authHeader()});
}
const getChrYears = () => {
  return axios.get(API_URLU + 'chr-years-desc', {headers:authHeader()});
}

const getChrMonthsByCalendarYear = (calendarYear) => {
  return axios.get(API_URLU + 'chr-months-year/' + calendarYear, {headers:authHeader()});
}

const getChrMonths = () => {
  return axios.get(API_URLU + 'chr-months', {headers:authHeader()});
}

const getCfindChrPayMonthSummariesByPeriod = (period) => {
  return axios.get(API_URLU + 'chr-pay-month-summaries-period/' + period, {headers:authHeader()});
}

const getEmpCategoryByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'icr_employee_category_cmpid/' + cmpId, { headers: authHeader() });
};

const getEmployeeByCategoryCodeCmpId = (code, cmpId) => {
  return axios.get(API_URLU + 'chr_by_category_cmpid/' + code + '/' + cmpId, { headers: authHeader() });
};

const getEmployeeByCodeCmpId = (code, cmpId) => {
  return axios.get(API_URLU + 'chr_by_code_cmpid/' + code + '/' + cmpId, { headers: authHeader() });
};

const getUserHrCompanies = (usrId, sstId) => {
  return axios.get(API_URLU + 'usr-hr-companies/' + usrId + '/' + sstId, { headers: authHeader() });
};

const findPayParamsByCmpId = (cmpId) =>{
  return axios.get(API_URLU + 'list-pay-param-cmpid?cmpId=' + cmpId, {headers: authHeader()});
}

const postPayParams = (data) => {
  return axios.post(API_URLU + 'chr-pay-params', data, { headers: authHeader() });
};

const putPayParams = (data) => {
  return axios.put(API_URLU + 'chr-pay-params/' + data.pypId, data, { headers: authHeader() });
};

const postPayParamDtls = (data) => {
  return axios.post(API_URLU + 'chr-pay-params-dtls', data, { headers: authHeader() });
};

const putPayParamDtls = (data) => {
  return axios.put(API_URLU + 'chr-pay-params-dtls/' + data.pydId, data, { headers: authHeader() });
};

const postPayParamExcls = (data) => {
  return axios.post(API_URLU + 'chr-pay-params-excls', data, { headers: authHeader() });
};

const putPayParamExcls = (data) => {
  return axios.put(API_URLU + 'chr-pay-params-excls/' + data.pyeId, data, { headers: authHeader() });
};

const getAllPayParamDtls = (data) => {
  return axios.get(API_URLU + 'chr-pay-params-dtls-cmpid?cmpId=' + data.cmpId, {headers: authHeader()});
}

const getPayParamDtls = (data) => {
  return axios.get(API_URLU + 'chr-pay-params-dtls?pypId=' + data.pypId, {headers: authHeader()});
}

const getAllPayParamExcls = (data) => {
  return axios.get(API_URLU + 'chr-pay-params-excls-cmpid?cmpId=' + data.cmpId, {headers: authHeader()});
}

const getPayParamExcls = (data) => {
  return axios.get(API_URLU + 'chr-pay-params-excls?pypId=' + data.pypId , {headers: authHeader()});
}

const getContractTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-contract-general-codes', {headers:authHeader()});
}

const getUserPermittedChrEmpCategories = (email) => {
  return axios.get(API_URLU + 'chr-emp-categories?email=' + email, {headers:authHeader()});
}

const getChrEmpCategoriesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'chr-emp-categories-cmp?cmpId=' + cmpId, {headers:authHeader()});
}

const getAllChrEmpCategories = () => {
  return axios.get(API_URLU + 'all-chr-emp-categories', {headers:authHeader()});
}

const getChrFundingSourceGeneralCodesByCmpId = () => {
  return axios.get(API_URLU + 'chr-funding-general-codes', {headers:authHeader()});
}

const getChrRelationTypesByCmpId = () => {
  return axios.get(API_URLU + 'chr-relation-types', {headers:authHeader()});
}

const postEmployeeRelation = (data) => {
  return axios.post(API_URLU + 'chr-emp-relations', data, { headers: authHeader() });
};

const putEmployeeRelation = (data) => {
  return axios.put(API_URLU + 'chr-emp-relations/' + data.erlId, data, { headers: authHeader() });
};

const getEmployeeRelationsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-emp-relations?employeeCode=' + data.employeeCode, {headers:authHeader()});
}

const getEmployeeItemsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'cst-emp-items?&employeeCode=' + data.employeeCode, {headers:authHeader()});
}

const getEmployeeLeavesByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-emp-leaves?employeeCode=' + data.employeeCode, {headers:authHeader()});
}

const getEmployeeRefereesByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-referees?employeeCode=' + data.employeeCode, {headers:authHeader()});
}

const getEmployeeQualificationsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-emp-qualifications?employeeCode=' + data.employeeCode, {headers:authHeader()});
}

const getChrCompany = (cmpId) => {
  return axios.get(API_URLU + 'chr-company?cmpId=' +cmpId, {headers:authHeader()});
}

const getChrCompanyBranches = () => {
  return axios.get(API_URLU + 'branch', {headers:authHeader()});
}

const getActiveChrEmployeesByCmp = () => {
  return axios.get(API_URLU + 'chr-active-employees', {headers:authHeader()});
}

const getChrJobTitlesByCmp = () => {
  return axios.get(API_URLU + 'chr-job-titles' , {headers:authHeader()});
}

const getChrCompanyDepartments = () => {
  return axios.get(API_URLU + 'cms-departments', {headers:authHeader()});
}

const getChrJobGroupsByCmp = () => {
  return axios.get(API_URLU + 'chr-job-groups', {headers:authHeader()});
}

const getChrLeaveTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-leave-types', {headers:authHeader()});
}

const getChrAnnualLeaveTypesByCmp = () => {
  return axios.get(API_URLU + 'chr-annual-leave-types', {headers:authHeader()});
}

const postEmployeeLeave = (data) => {
  return axios.post(API_URLU + 'chr-emp-leaves', data, { headers: authHeader() });
};

const putEmployeeLeave = (data) => {
  return axios.put(API_URLU + 'chr-emp-leaves/' + data.elvId, data, { headers: authHeader() });
};

const getChrCoursesByCmp = () => {
  return axios.get(API_URLU + 'chr-courses', {headers:authHeader()});
}

const postEmployeeQualification = (data) => {
  return axios.post(API_URLU + 'chr-emp-qualifications', data, { headers: authHeader() });
};

const putEmployeeQualification = (data) => {
  return axios.put(API_URLU + 'chr-emp-qualifications/' + data.mqlId, data, { headers: authHeader() });
};

const postEmployeeReferee = (data) => {
  return axios.post(API_URLU + 'chr-referees', data, { headers: authHeader() });
};

const putEmployeeReferee = (data) => {
  return axios.put(API_URLU + 'chr-referees/' + data.rfrId, data, { headers: authHeader() });
};

const getFixedAssetCategoriesByCmp = () => {
  return axios.get(API_URLU + 'cfs-asset-cat-details', {headers:authHeader()});
}

const getItemsByCategory = (categoryCode) => {
  return axios.get(API_URLU + 'cfs-asset-definitions?categoryCode=' +categoryCode, {headers:authHeader()});
}

const postEmployeeItem = (data) => {
  return axios.post(API_URLU + 'cst-emp-items', data, { headers: authHeader() });
};

const putEmployeeItem = (data) => {
  return axios.put(API_URLU + 'cst-emp-items/' + data.eitId, data, { headers: authHeader() });
};

const postEmployeeRecurrent = (data) => {
  return axios.post(API_URLU + 'chr_emp_recurrent', data, { headers: authHeader() });
};

const putEmployeeRecurrent = (data) => {
  return axios.put(API_URLU + 'chr_emp_recurrent/' + data.ercId, data, { headers: authHeader() });
};

const postEmpOtherMonthlies = (data) => {
  return axios.post(API_URLU + 'chr-emp-other-monthlies', data, { headers: authHeader() });
};

const putEmpOtherMonthlies = (data) => {
  return axios.put(API_URLU + 'chr-emp-other-monthlies/' + data.eomId, data, { headers: authHeader() });
};

const getEmployeeOtherMonthlies = (data) => {
  return axios.get(API_URLU + 'chr-emp-other-monthlies?employeeCode=' +data.employeeCode, {headers:authHeader()});
}

const postEmpExternalContr = (data) => {
  return axios.post(API_URLU + 'chr-emp-external-contr', data, { headers: authHeader() });
};

const putEmpExternalContr = (data) => {
  return axios.put(API_URLU + 'chr-emp-external-contr/' + data.extId, data, { headers: authHeader() });
};

const getEmployeeExternalContr = (data) => {
  return axios.get(API_URLU + 'chr-emp-external-contr?employeeCode=' +data.employeeCode , {headers:authHeader()});
}

const postEmpBenefits = (data) => {
  return axios.post(API_URLU + 'chr-emp-benefits', data, { headers: authHeader() });
};

const putEmpBenefits = (data) => {
  return axios.put(API_URLU + 'chr-emp-benefits/' + data.ebnId, data, { headers: authHeader() });
};

const getEmployeeBenefits = (data) => {
  return axios.get(API_URLU + 'chr-emp-benefits?employeeCode=' +data.employeeCode, {headers:authHeader()});
}

const getCompanyBranches = (id) => {
  return axios.get(API_URLU + "company-branches/" + id, {
    headers: authHeader(),
  });
};

const getBranch = (id) => {
  return axios.get(API_URLU + "branch/" + id, { headers: authHeader() });
};

const putBranch = (id, data) => {
  return axios.put(API_URLU + "branch/" + id, data, { headers: authHeader() });
};
const postBranch = (data) => {
  return axios.post(API_URLU + "branch", data, { headers: authHeader() });
};

const getDepartmentsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cms-department-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};


const postDepartments = (data) => {
  return axios.post(API_URLU + "cms-departments", data, {
    headers: authHeader(),
  });
};

const updateDepartments = (data) => {
  return axios.put(API_URLU + "cms-departments/" + data.dprId, data, {
    headers: authHeader(),
  });
};

const getDepartmentsById = (dprId) => {
  return axios.get(API_URLU + "cms-departments-id/" + dprId, {
    headers: authHeader(),
  });
};

const postCostCenters = (data) => {
  return axios.post(API_URLU + "cost-centers", data, {
    headers: authHeader(),
  });
};

const updateCostCenters = (data) => {
  return axios.put(API_URLU + "cost-centers/" + data.cstId, data, {
    headers: authHeader(),
  });
};

const getCostCentersById = (cstId) => {
  return axios.get(API_URLU + "cost-centers-id/" + cstId, {
    headers: authHeader(),
  });
};

const getCostCentersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cost-centers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getUserRights = (data) => {
  return axios.get(
    API_URLU +
    "userRights?sstId=" +
    data.sstId +
    "&username=" +
    data.username +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const putCompany = (cmpId, data) => {
  return axios.put(API_URLU + "company/" + cmpId, data, {
    headers: authHeader(),
  });
};

const getGeneralCodes = (cmpId, codeType) => {
  return axios.get(API_URLU + "cms-general-codes/" + cmpId + "/" + codeType, {
    headers: authHeader(),
  });
};

const postPayApproveRights = (data) => {
  return axios.post(API_URLU + 'chr-pay-approv-rights', data, { headers: authHeader() });
};

const putPayApproveRights = (data) => {
  return axios.put(API_URLU + 'chr-pay-approv-rights/' + data.parId, data, { headers: authHeader() });
};

const gePayApproveRights = () => {
  return axios.get(API_URLU + 'chr-pay-approv-rights', {headers:authHeader()});
}

const postUserPermittedCats = (data) => {
  return axios.post(API_URLU + 'chr-user-permitted-cats', data, { headers: authHeader() });
};

const putUserPermittedCats = (data) => {
  return axios.put(API_URLU + 'chr-user-permitted-cats/' + data.upcId, data, { headers: authHeader() });
};

const getUserPermittedCats = (data) => {
  return axios.get(API_URLU + 'chr-user-permitted-cats?userName=' +data.userName, {headers:authHeader()});
}

const postEmployeecategories = (data) => {
  return axios.post(API_URLU + 'chr-emp-categories', data, { headers: authHeader() });
};

const putEmployeeCategories = (data) => {
  return axios.put(API_URLU + 'chr-emp-categories/' + data.ectId, data, { headers: authHeader() });
};

const getAllPermittedEmployees = (data) => {
  return axios.get(API_URLU + 'chr-all-permitted-employee?email=' + data.email, { headers: authHeader() });
};

const closeCompanyPeriods = (data) => {
  return axios.get(
    API_URLU +
      'close-company-periods?period=' +
      data.period +
      '&cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username ,
    { headers: authHeader() }
  );
};

const clearMonthlyFigures = (data) => {
  return axios.get(
    API_URLU +
      'clear-monthly-figures?cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode+
      '&empCode=' +
      data.empCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const approveGeneratedMonthlyFigures = (data) => {
  return axios.get(
    API_URLU +
      'approve-monthly-payroll?cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode +
      '&period=' +
      data.period +
      '&username=' +
      data.username +
      '&approvalStatus=' +
      data.approvalStatus,
    { headers: authHeader() }
  );
};

const getMonthlyInputsByPeriodAndCategoryCode = (data) => {
  return axios.get(API_URLU + 'chr-monthly-inputs?period=' + data.period + '&categoryCode=' + data.categoryCode, { headers: authHeader() });
};

const getMonthlyInputDtlsByBatchId = (data) => {
  return axios.get(API_URLU + 'chr-monthly-input-dtls?period=' + data.period + '&batchId=' + data.batchId, { headers: authHeader() });
};

const getMonthlyInputsBatchId = () => {
  return axios.get(
    API_URLU +
      'get-monthly-inputs-batchid',
    { headers: authHeader() }
  );
};

const postMonthlyInputs = (data) => {
  return axios.post(API_URLU + 'chr-monthly-inputs', data, { headers: authHeader() });
};

const putMonthlyInputs = (data) => {
  return axios.put(API_URLU + 'chr-monthly-inputs/' + data.mtiId, data, { headers: authHeader() });
};

const postMonthlyInputDtls = (data) => {
  return axios.post(API_URLU + 'chr-monthly-input-dtls', data, { headers: authHeader() });
};

const putMonthlyInputDtls = (data) => {
  return axios.put(API_URLU + 'chr-monthly-input-dtls/' + data.mdtId, data, { headers: authHeader() });
};

const getEmployeeOvertimeAmount = (data) => {
  return axios.get(
    API_URLU +
      'get-employee-overtime?employeeCode=' +
      data.employeeCode +
      '&period=' +
      data.period +
      '&paramCode=' +
      data.paramCode +
      '&hoursWorked=' +
      data.hoursWorked,
    { headers: authHeader() }
  );
};

const getTempPayReports = () => {
  return axios.get(API_URLU + 'chr-temp-pay-reports', { headers: authHeader() });
};

const runPayrollReport = (dts) => {
  return axios.get(
    API_URLU +
    "payroll-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&period=" +
    dts.period +
    "&categoryCode=" +
    dts.categoryCode +
    "&cmpId=" +
    dts.cmpId +
    "&employeeCode=" +
    dts.employeeCode +
    "&empName=" +
    dts.empName +
    "&nationalId=" +
    dts.nationalId +
    "&pinNo=" +
    dts.pinNo +
    "&nssfNo=" +
    dts.nssfNo+
    "&nhifNo=" +
    dts.nhifNo+
    "&bankAccNo=" +
    dts.bankAccNo +
    "&categoryName=" +
    dts.categoryName +
    "&catId=" +
    dts.catId +
    "&bankName=" +
    dts.bankName+
    "&paramCode=" +
    dts.paramCode+
    "&paramName=" +
    dts.paramName,
    { headers: authHeader() }
  );
};

const getTenants = (id) => {
  return axios.get(API_URLU + "get-tenant?tenantId=" + id, {
    headers: authHeader(),
  });
};

const setTenants = (id) => {
  return axios.get(API_URLU + "set-tenants?tenantId=" + id, {
    headers: authHeader(),
  });
};

const tenantPost = (id) => {
  return axios.post(API_URLU + "create?tenantId=" + id, {
    headers: authHeader(),
  });
};

const companySystemLink = (data) => {
  return axios.get(
    API_URLU +
    "company-system-link?cmpId=" +
    data.cmpId +
    "&sstId=" +
    data.sstId +
    "&email=" +
    data.email,
    { headers: authHeader() }
  );
};

const adminSystemLink = (data) => {
  return axios.get(
    API_URLU +
    "admin-system-link?cmpId=" +
    data.cmpId +
    "&sstId=" +
    data.sstId +
    "&usrId=" +
    data.usrId +
    "&email=" +
    data.email,
    { headers: authHeader() }
  );
};

const companyMenuLink = (data) => {
  return axios.get(
    API_URLU + "link-cmp-menus?cmpId=" + data.cmpId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const generateCompanySerials = (data) => {
  return axios.get(
    API_URLU + "generate-cmp-serials?cmpId=" + data.cmpId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const getHrUserCompanies = (data) => {
  return axios.get(
    API_URLU + "hr-user-companies?usrId=" + data.usrId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const getBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getActiveBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-actbank-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postBankHeaders = (data) => {
  return axios.post(API_URLU + "sac-bank-headers", data, {
    headers: authHeader(),
  });
};

const putBankHeaders = (sysBankId, data) => {
  return axios.put(API_URLU + "sac-bank-headers/" + sysBankId, data, {
    headers: authHeader(),
  });
};

const getBankHeadersById = (sysBankId) => {
  return axios.get(API_URLU + "sac-bank-headers-id/" + sysBankId, {
    headers: authHeader(),
  });
};

const delBankHeaders = (sysBankId) => {
  return axios.delete(API_URLU + "sac-bank-headers/" + sysBankId, {
    headers: authHeader(),
  });
};

const getBankBranchesBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postBankBranches = (data) => {
  return axios.post(API_URLU + "sac-bank-branches", data, {
    headers: authHeader(),
  });
};

const putBankBranches = (sysBranchId, data) => {
  return axios.put(API_URLU + "sac-bank-branches/" + sysBranchId, data, {
    headers: authHeader(),
  });
};

const getBankBranchesById = (sysBranchId) => {
  return axios.get(API_URLU + "sac-bank-branches-id/" + sysBranchId, {
    headers: authHeader(),
  });
};

const getBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(
    API_URLU +
    "sac-bank-branches-byheader-cmpid/" +
    bankHeaderCode +
    "/" +
    cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getActBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(
    API_URLU +
    "sac-actbank-branches-byheader-cmpid/" +
    bankHeaderCode +
    "/" +
    cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getBankBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const delBankBranches = (sysBranchId) => {
  return axios.delete(API_URLU + "sac-bank-branches/" + sysBranchId, {
    headers: authHeader(),
  });
};

const updatebankBranchCode = (data) => {
  return axios.get(
    API_URLU + "update-branch-bank-code?sysBankId=" + data.sysBankId,
    { headers: authHeader() }
  );
};

const getBusinessLines = () => {
  return axios.get(API_URLU + "business-lines", { headers: authHeader() });
};

const getEmployeePeriodsByEmployeeCode = (data) => {
  return axios.get(API_URLU + 'chr-employee-periods-byemployee?empCode=' + data.employeeCode, { headers: authHeader() });
};

const postEmployeePeriods = (data) => {
  return axios.post(API_URLU + 'chr-employee-periods', data, { headers: authHeader() });
};

const putEmployeePeriods = (data) => {
  return axios.put(API_URLU + 'chr-employee-periods/' + data.eprId, data, { headers: authHeader() });
};

const getPeriodsByCategory = (data) => {
  return axios.get(
    API_URLU +
      'pay-period-category?period=' +
      data.period +
      '&cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode,
    { headers: authHeader() }
  );
};

const getCompanyCategoryBranches = (data) => {
  return axios.get(API_URLU + "cmp-category-branches?categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getMonthlyPayReports = (data) => {
  return axios.get(API_URLU + "chr-monthly-pay-reports", {
    headers: authHeader(),
  });
};

const getYearlyPayReports = (data) => {
  return axios.get(API_URLU + "chr-yearly-pay-reports", {
    headers: authHeader(),
  });
};

const getGlobalSummaryCsv = (data) => {
  return axios.get(API_URLU + "chr-global-summary-csv?catId=" + data.catId + "&period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getFinalRemmitanceCsv = (data) => {
  return axios.get(API_URLU + "chr-final-remmitance-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getProvisionalRemmitanceCsv = (data) => {
  return axios.get(API_URLU + "chr-provisional-remmitance-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getCombinedDeductionsSummaryCsv = (data) => {
  return axios.get(API_URLU + "chr-payded-summary-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getCombinedDeductionsDetailedCsv = (data) => {
  return axios.get(API_URLU + "chr-payded-detailed-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getStatutoryReportCsv = (data) => {
  return axios.get(API_URLU + "chr-statutory-ded-csv?period=" + data.period + "&paramCode=" + data.paramCode + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getPayeReportCsv = (data) => {
  return axios.get(API_URLU + "chr-paye-report-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

const getSalaryReviewCsv = (data) => {
  return axios.get(API_URLU + "chr-salary-review-csv?period=" + data.period + "&categoryCode=" + data.categoryCode, {
    headers: authHeader(),
  });
};

export default {
  getUserById,  getUsers,  postUser,  getByUsername,  getCompById,  getCompanies,  postComp,  getSystemById,  getSystems,
  postSystem,  postUserComp,  postUserSystems,  getUserComp,  getCompSystems,  getUserCompSystems,
  getUserCompUSystems,  getCustomerById,  getCustomers,  postCustomer,  putCustomer,  getEmployeeByCode,  getEmployeeByUsername,
  getEmployeeDepartments,  getEmployeeByCategoryCode,  getEmployeeByDepartmentCode,  getEmployees,  getPagedEmployees,  postEmployee,
  putEmployee,  getClassification,  getGeneral,  getFiles,  saveInvoice,  getInvoiceInfo,  getScheduledLeaves,
  postLeaveSchedule,  getLeaveAccruals,  getLeaveApplications,  postLeaveApplication,  getLeaveTransactions,  getLeaveRejections,  getLeaveTypes,
  getReturnDate,  uploadFile,  uploadExcel,  postTempBranch,  getTempBranch,  getEmpCategory,  postEmpCategory,  getBanks,
  getEmpRecurrents,  getPayPeriods,  getChrTempMonthlies,  getChrMonthliesView,  getMonthlyFigures,  purgeMonthlyFigures,
  updatePass,  updateUser,  updateUserImg,  getApprovalRights,  getProvpayvarsum2,  getReports,  runReport,  preparatoryApp,
  verificationApp,  finalApp,  getPayMonthSummary,  getFinalMonthliesCount,  getCloseCurrentPeriod,
  getRecurrents_ed,  updateRecurrents_ed,  saveRecurrents_ed,  getPayParams,  getEmployeeById,  getLeaveAccrualsvw,  getLeaveApplicationsvw,
  getLeaveTransactionsvw,  getEmployeeLeaveByDepartmentCode,  getMenuLevels,  getAttendance,  genAttendanceAll,
  getTaskScheduleByEmpCode,  getTaskRequestByEmpCode,  getDepartments,  getHdeskTypes,  postTaskRequest,  getTaskRequestByDepCode,
  getDepartEmployees,  postTaskSchedule,  getHodTaskApproval,  postDoneStatus,  postCloseStatus,  postDiscardedStatus,
  getAppraisalTypes,postAppraisalTasks,getAppraisalTaskAreas,saveAppraisalTaskAreas,generateAppraisalTemplate,getAppraisalSchedules,
  getAppraisalScoresa,getAppraisalScores,updateAppraisalScores,getUserAppraisalSchedules,fetchAppEdit,signDocument,printRept,
  getPendingRegs,getItemReqs,storeRequisitions,getApprovedReqs,getRejectedReqs,getRejectedApprovedRegs,updateItemReq,updateItemReqStatus,
  getAllApprovedReqs,updateItemIssued,getAllIssuedReqs,recallApproval,getIndItem,updateItemUnit,getCompletedTasks,getPendingTasks,changeTaskState,
  getDiscardedTasks,  getAllApprovedReqs,updateItemIssued,getAllIssuedReqs,recallApproval,getIndItem,updateItemUnit,getAppPositions,getAppQualifications,
  PostAppQualifications,updateAppQualifications,getAppextraCur,PostAppextraCur,updateAppextraCur,getEmployeebyCmp,listPayParams,findPayParamById,fetchPayCodes,fetchAccoutCodes,
  deleteChrLeaveApplications,fetchMailingList,sendLeaveUpdates,sendEmailAlerts,savePayParams,loanIntParams,
  deleteChrLeaveApplications,fetchMailingList,sendLeaveUpdates,sendEmailAlerts, getChrYears, getChrMonthsByCalendarYear, getCfindChrPayMonthSummariesByPeriod,
  getEmpCategoryByCmpId, getEmployeeByCategoryCodeCmpId, getEmployeeByCodeCmpId, getUserHrCompanies, findPayParamsByCmpId, postPayParams, putPayParams,
  postPayParamDtls, putPayParamDtls, postPayParamExcls, putPayParamExcls, getAllPayParamDtls, getPayParamDtls, getAllPayParamExcls, getPayParamExcls,
  getContractTypesByCmp, getChrFundingSourceGeneralCodesByCmpId, getUserPermittedChrEmpCategories, getChrRelationTypesByCmpId, postEmployeeRelation,
  putEmployeeRelation, getEmployeeRelationsByEmployeeCode, getEmployeeItemsByEmployeeCode, getEmployeeLeavesByEmployeeCode, getEmployeeRefereesByEmployeeCode,
  getEmployeeQualificationsByEmployeeCode, getChrCompany, getChrCompanyBranches, getActiveChrEmployeesByCmp, getChrJobTitlesByCmp, getChrCompanyDepartments,
  getChrJobGroupsByCmp, getChrLeaveTypesByCmp, getChrAnnualLeaveTypesByCmp, postEmployeeLeave, putEmployeeLeave, getChrCoursesByCmp, postEmployeeQualification,
  putEmployeeQualification, postEmployeeReferee, putEmployeeReferee, getFixedAssetCategoriesByCmp, getItemsByCategory, postEmployeeItem, putEmployeeItem,
  postEmployeeRecurrent, putEmployeeRecurrent, getEmployeeOtherMonthlies, putEmpOtherMonthlies, postEmpOtherMonthlies, postEmpExternalContr, putEmpExternalContr,
  getEmployeeExternalContr, postEmpBenefits, putEmpBenefits, getEmployeeBenefits, getCompanyBranches, getBranch, getDepartmentsByCmpId, postDepartments,
  updateDepartments, getDepartmentsById, postCostCenters, updateCostCenters, getCostCentersById, getCostCentersByCmpId, getUserRights, putCompany, putBranch,
  postBranch, getGeneralCodes, postPayApproveRights, putPayApproveRights, gePayApproveRights, postUserPermittedCats, putUserPermittedCats, getUserPermittedCats,
  getAllChrEmpCategories, postEmployeecategories, putEmployeeCategories, getAllPermittedEmployees, getChrEmpCategoriesByCmpId, getChrMonths, closeCompanyPeriods,
  clearMonthlyFigures, approveGeneratedMonthlyFigures, getChrEerMonthliesView, getMonthlyInputsByPeriodAndCategoryCode, getMonthlyInputDtlsByBatchId,
  getMonthlyInputsBatchId, postMonthlyInputs, putMonthlyInputs, postMonthlyInputDtls, putMonthlyInputDtls, getEmployeeOvertimeAmount, getTempPayReports,
  runPayrollReport, getTenants, setTenants, tenantPost, companySystemLink, adminSystemLink, companyMenuLink, generateCompanySerials, getHrUserCompanies,
  getBankBranchesByHeader, getBankHeadersBySacco, getActiveBankHeadersBySacco, postBankHeaders, putBankHeaders, getBankHeadersById, delBankHeaders,
  getBankBranchesBySacco, postBankBranches, putBankBranches, getBankBranchesById, getActBankBranchesByHeader, getBankBranchesByCmpId, delBankBranches,
  updatebankBranchCode, getBusinessLines, getEmployeePeriodsByEmployeeCode, postEmployeePeriods, putEmployeePeriods, getPeriodsByCategory, getCompanyCategoryBranches,
  getMonthlyPayReports, getYearlyPayReports, getGlobalSummaryCsv, getFinalRemmitanceCsv, getProvisionalRemmitanceCsv, getCombinedDeductionsSummaryCsv,
  getCombinedDeductionsDetailedCsv, getStatutoryReportCsv, getPayeReportCsv, getSalaryReviewCsv
  
}
